__turbopack_context__.v({
  "color": "YgRdga_color",
  "grid": "YgRdga_grid",
  "hex": "YgRdga_hex",
  "info": "YgRdga_info",
  "name": "YgRdga_name",
  "palette": "YgRdga_palette",
  "proportionsChart": "YgRdga_proportionsChart",
  "proportionsImage": "YgRdga_proportionsImage",
  "proportionsSection": "YgRdga_proportionsSection",
  "proportionsText": "YgRdga_proportionsText",
  "row": "YgRdga_row",
  "section": "YgRdga_section",
  "sectionTitle": "YgRdga_sectionTitle",
  "small": "YgRdga_small",
  "swatch": "YgRdga_swatch",
  "value": "YgRdga_value",
});
